import { render, staticRenderFns } from "./DetalhePassaporte.vue?vue&type=template&id=3afadd4c"
import script from "./DetalhePassaporte.vue?vue&type=script&lang=js"
export * from "./DetalhePassaporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports